import { render, staticRenderFns } from "./v-session-timeout.vue?vue&type=template&id=21544f57&"
import script from "./v-session-timeout.vue?vue&type=script&lang=js&"
export * from "./v-session-timeout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports